import { Component } from "@mcleod/components";
import { DatePart, LogManager } from "@mcleod/core";

export type TimePart =  DatePart.HOUR | DatePart.MINUTE | DatePart.SECOND;

const log = LogManager.getLogger("common.CallBackScheduler");

export class CallBackScheduler {
    private readonly callBack: () => void;
    private comp: Component;
    private _timePart: TimePart
    private timerId: number;

    constructor(trackedComp: Component, callback: () => void, timePart: TimePart,  startTimer=false) {
        this.comp = trackedComp;
        this.callBack = callback;
        this._timePart = timePart;
        if (startTimer) this.startTimer();
    }

    public startTimer() {
        log.debug("Starting timer");
        this.setTimer();
        this.comp.addUnmountListener(() => this.stopTimer());
    }

    public stopTimer() {
        log.debug("Clearing timer");
        clearTimeout(this.timerId);
        this.timerId = null;
    }

    set timePart(timePart: TimePart) {
        this._timePart = timePart;
    }

    private setTimer() {
        this.timerId = window.setTimeout(() => {
                this.callBack();
                this.setTimer();
            }, this.getNextRun());
    }

    private getNextRun(): number {
        const now = new Date();
        const next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), this.getHours(now), this.getMinutes(now), this.getSeconds(now));

        return next.getTime() - now.getTime();
    }

    private getSeconds(date: Date): number {
        if (DatePart.SECOND !== this._timePart)
            return 0;
        return date.getSeconds() + 1;
    }

    private getMinutes(date: Date): number {
        if (DatePart.HOUR === this._timePart)
            return 0;
        let result = date.getMinutes();
        if (DatePart.MINUTE === this._timePart)
            result += 1;

        return result;
    }

    private getHours(date: Date): number {
        let result = date.getHours();
        if (DatePart.HOUR === this._timePart)
            result += 1;
        return result;
    }
}
